export default __webpack_public_path__ + "static/media/preview.73c3cda3.png";